module.exports = __webpack_public_path__ + "static/monthly_challenges_screen-5cbe41619f6c7ad9bb5566ad1e340c8b.png";